import React, { useState, useEffect } from "react";
import _ from "lodash";
import { showNotification } from "@mantine/notifications";
import { useForceUpdate } from "@mantine/hooks";
import {
  Button,
  Table,
  Group,
  Text,
  Chip,
  Space,
  Title,
  Grid,
  Card,
  Checkbox,
  Divider,
  Tabs,
  Badge,
  LoadingOverlay,
  Menu,
  Switch,
  Stack,
  Center,
  ActionIcon,
  Tooltip,
  Anchor,
} from "@mantine/core";

import { useCellRender } from "../hooks/useCellRender";

import {
  IconFile,
  IconUser,
  IconTrash,
  IconRefresh,
  IconDotsVertical,
} from "@tabler/icons";
import { Accordion, useMantineTheme } from "@mantine/core";
import { useFormatter } from "../hooks/useFomatter";
import { useServerApi } from "../hooks/userServerApi";
import { useForm } from "@mantine/form";
import useDeepCompareEffect from "../hooks/useDeepCompareEffect";
import ReactJson from "react-json-view";
import { openFileUrl } from "../utils/openReport";

const RowHeader = ({ payment, payrollStatus, onRemovePayment }) => {
  const { wallet, bids, total } = payment ?? {};
  const { user, members } = wallet ?? {};
  const users = members?.map((m) => m.user);
  const [cellRender] = useCellRender();
  const [formatter] = useFormatter();
  const [api] = useServerApi();

  const printPayrollSlip = async (paymentId) => {
    try {
      const result = await api.PayrollPayment.printPdf(paymentId);
      if (result.data && result.data.url)
        return await openFileUrl(result.data.url);
      if (result.error) throw result.error;
    } catch (error) {
      console.log(error);
    }
  };

  const resignAmount = bids
    .filter((b) => b.code.includes("B-USER-RESIGN"))
    .reduce((a, c) => a + c.paidAmount, 0);
  return (
    <>
      {wallet && (
        <Grid justify="space-between">
          <Grid.Col span={3}>
            <>
              {user && (
                <div>
                  {/* {user.staffId && (
										<Badge mb={"xs"} color="green">
											{user.staffId}
										</Badge>
									)} */}
                  {/* <Badge mb={"xs"}>{wallet._id}</Badge> */}
                  {cellRender.User(user)}
                </div>
              )}

              {!user && wallet.name && (
                <div>
                  {wallet.name && <Badge mb={"xs"}>{wallet.name}</Badge>}
                  {cellRender.Users(users)}
                  {/* <Text size={"xs"} color="dimmed" mt={"xs"}>
                                     {wallet.name}
                                 </Text> */}
                </div>
              )}
            </>
          </Grid.Col>
          <Grid.Col span={3}>
            <Stack align={"flex-start"} spacing="xs">
              <Title order={3}>{bids.length}</Title>
              <Text size={"xs"} color="dimmed">
                Total bids
              </Text>
            </Stack>
          </Grid.Col>
          <Grid.Col span={3}>
            {user && (
              <div>
                <Title order={3}>
                  {cellRender.Mask(
                    user?.consultantInfo?.paymentMethods.accNumber,
                    "*",
                    3,
                    4
                  )}
                </Title>
                <Text size={"xs"} color="dimmed">
                  Bank Account
                </Text>
              </div>
            )}
          </Grid.Col>
          <Grid.Col span={2}>
            <Group>
              <div>
                <Title order={3}>{formatter.currency(total)}</Title>

                <Text size={"xs"} color="dimmed">
                  Total Payoll Amount
                </Text>
                {resignAmount < 0 && (
                  <Text size={"xs"} color={"red"}>
                    Incld. Team Resign {formatter.currency(resignAmount)}
                  </Text>
                )}
              </div>
            </Group>
          </Grid.Col>

          <Grid.Col span={1}>
            <div onClick={(e) => e.stopPropagation()}>
              <Menu shadow="md" mt="xs" position="bottom-end">
                <Menu.Target>
                  <ActionIcon
                    variant="light"
                    size="sm"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <IconDotsVertical size={16} />
                  </ActionIcon>
                </Menu.Target>

                <Menu.Dropdown>
                  <Menu.Item
                    color="red"
                    disabled={payment.status === "COMPLETED"}
                    onClick={(e) => {
                      onRemovePayment(payment._id);
                    }}
                  >
                    Remove Payment
                  </Menu.Item>
                  <Menu.Item
                    onClick={(e) => {
                      printPayrollSlip(payment._id);
                    }}
                  >
                    Print Payroll Slip
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </div>
          </Grid.Col>
        </Grid>
      )}
    </>
  );
};

const RowContent = ({ payment, onRemoveBid, payrollStatus }) => {
  const { bids } = payment;
  const [cellRender] = useCellRender();
  const [selectedBids, setSelectedBids] = useState([]);
  return (
    <>
      <Divider
        mt={"xl"}
        mb={"xl"}
        my="xs"
        label="Bid Details"
        labelPosition="center"
        variant="dashed"
      />
      <Group my="md">
        <Text size="xs">Selected</Text>
        <Badge size="xs" radius="xs">
          {selectedBids.length}
        </Badge>

        <Menu shadow="md">
          <Menu.Target>
            <ActionIcon
              disabled={selectedBids.length === 0}
              variant="light"
              size="sm"
            >
              <IconDotsVertical size={16} />
            </ActionIcon>
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Item
              onClick={async () => {
                const removed = await onRemoveBid(selectedBids);
                if (removed) {
                  setSelectedBids([]);
                }
              }}
            >
              Remove Selected
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>

      <Table fontSize={"sm"} striped highlightOnHover>
        <thead>
          <tr>
            <th>
              <Group>
                <Checkbox
                  size="xs"
                  checked={selectedBids.length === bids.length}
                  onChange={(e) => {
                    const checked = e.currentTarget.checked;
                    if (checked) {
                      setSelectedBids(bids.map((b) => b._id));
                    } else {
                      setSelectedBids([]);
                    }
                  }}
                />
              </Group>
            </th>
            <th></th>
            <th>Type</th>
            <th>Bid ID</th>
            <th>Level</th>

            <th>Amount</th>
            <th>Refer </th>
            <th>Status</th>
            {payrollStatus === "PENDING" && <th>Action</th>}
          </tr>
        </thead>
        <tbody>
          {bids &&
            bids.map((b, index) => (
              <tr
                key={index}
                // onDoubleClick={() => {
                //   const checked = !selectedBids.includes(b._id);
                //   if (checked) {
                //     setSelectedBids([...selectedBids, b._id]);
                //   } else {
                //     setSelectedBids(selectedBids.filter((id) => id !== b._id));
                //   }
                // }}
                style={{ cursor: "pointer" }}
              >
                <td>
                  <Checkbox
                    size="xs"
                    checked={selectedBids.includes(b._id)}
                    onChange={(e) => {
                      const checked = e.currentTarget.checked;
                      if (checked) {
                        setSelectedBids([...selectedBids, b._id]);
                      } else {
                        setSelectedBids(
                          selectedBids.filter((id) => id !== b._id)
                        );
                      }
                    }}
                  />
                </td>
                <td>{index + 1}</td>

                <td>{b.type}</td>
                <td>
                  <div>{b.code}</div>
                  {b.order && (
                    <div>
                      {/* {`${b.order?.code}`} */}
                      {b.order?.debitNote && (
                        <Anchor
                          href={`/m/gi/debitNote?id=${b.order?.debitNote?._id}&mode=edit`}
                          target="_blank"
                        >
                          {`${b.order.debitNote?.code}`}
                        </Anchor>
                      )}
                      <Group noWrap maw={350}>
                        {!b.order?.debitNote && (
                          <Anchor
                            href={`/management/order?id=${b.order?._id}&mode=edit`}
                            target="_blank"
                            miw={100}
                          >
                            {`${b.order?.code}`}
                          </Anchor>
                        )}

                        {b.order?.client && (
                          <Text size="xs" color="dimmed" lineClamp={1}>
                            {b.order?.client?.name}
                          </Text>
                        )}
                      </Group>
                    </div>
                  )}
                </td>
                <td>{b.level}</td>

                <td>{cellRender.Currency(b.paidAmount, b.paidCurrency)}</td>
                <td>{b.referFrom ? b.referFrom.user?.name : "--"}</td>

                <td>{cellRender.Status(b.status)}</td>
                {payrollStatus === "PENDING" && (
                  <td>
                    <Tooltip label="Remove from payroll">
                      <Text size="xs" color="dimmed" transform="uppercase">
                        Remove
                      </Text>
                    </Tooltip>
                  </td>
                )}
              </tr>
            ))}
        </tbody>
      </Table>
    </>
  );
};

export const ReferalRow = ({
  referal,
  onRemoveBid,
  payrollStatus,
  onRemovePayment,
}) => {
  return (
    referal && (
      <Accordion.Item value={referal._id}>
        <Accordion.Control>
          <RowHeader
            payment={referal}
            payrollStatus={payrollStatus}
            onRemovePayment={onRemovePayment}
          />
        </Accordion.Control>
        <Accordion.Panel>
          <RowContent
            payment={referal}
            onRemoveBid={onRemoveBid}
            payrollStatus={payrollStatus}
          />
        </Accordion.Panel>
      </Accordion.Item>
    )
  );
};

export const WalletRow = ({
  paymentId,
  onRemoveBid,
  payrollStatus,
  onRemovePayment,
}) => {
  const [payment, setPayment] = useState(null);
  const [api] = useServerApi();
  const fetch = async () => {
    const data = await api.Payroll.getPaymentDetail(paymentId);
    if (!data) return setPayment(null);
    setPayment(data.payment);
  };

  const handleRemoveBid = async (bidIds) => {
    await onRemoveBid(bidIds);
    await fetch();
  };

  useEffect(() => {
    fetch();
  }, [paymentId]);

  return (
    payment && (
      <Accordion.Item value={payment._id}>
        <Accordion.Control>
          <RowHeader
            payment={payment}
            payrollStatus={payrollStatus}
            onRemovePayment={onRemovePayment}
          />
        </Accordion.Control>
        <Accordion.Panel>
          <RowContent
            payment={payment}
            onRemoveBid={handleRemoveBid}
            payrollStatus={payrollStatus}
          />
        </Accordion.Panel>
      </Accordion.Item>
    )
  );
};

const WalletList = ({
  payments,
  onRemoveBid,
  payrollStatus,
  onRemovePayment,
}) => {
  // const rows = payments?.filter(({ wallet: w }) => w.type === type) ?? [];
  return (
    <>
      {payments && (
        <>
          {payments.length === 0 && (
            <Card>
              <Title order={6}>{`There are no payments`}</Title>
            </Card>
          )}
          {payments.map((payment, index) => (
            <WalletRow
              paymentId={payment}
              onRemoveBid={onRemoveBid}
              payrollStatus={payrollStatus}
              onRemovePayment={onRemovePayment}
            />
          ))}
        </>
      )}
    </>
  );
};

const PaymentTab = ({
  payments,
  onRemoveBid,
  payrollStatus,
  onRemovePayment,
}) => {
  // const [loading, setLoading] = useState(false);
  // const [api] = useServerApi();
  // const [payments, setPayments] = useState([]);

  // const fetchPaymentDetails = async () => {
  //     setLoading(true);
  //     let result = await api.Payroll.getPaymentDetails(paymentIds);
  //     console.log(result);

  //     setLoading(false);
  // };

  // useDeepCompareEffect(() => {
  //     fetchPaymentDetails();
  // }, [paymentIds]);
  const sorted = payments; //?.sort((a, b) => a.bids.length - b.bids.length);

  return (
    <Tabs defaultValue="pending">
      <Tabs.List>
        <Tabs.Tab value="pending" icon={<IconUser size={14} />}>
          Payments
        </Tabs.Tab>
        {/* <Tabs.Tab
                    value="missing"
                    icon={<IconBuildingSkyscraper size={14} />}
                >
                    Group
                </Tabs.Tab> */}
      </Tabs.List>

      <Tabs.Panel value="pending" pt="xl">
        <Accordion variant="separated">
          <WalletList
            payments={sorted}
            onRemoveBid={onRemoveBid}
            payrollStatus={payrollStatus}
            onRemovePayment={onRemovePayment}
          />
        </Accordion>
      </Tabs.Panel>

      {/* <Tabs.Panel value="missing" pt="xl">
                <Accordion variant="separated">
                    {!loading && (
                        <WalletList type="GROUP" payments={payments} />
                    )}
                </Accordion>
            </Tabs.Panel> */}
    </Tabs>
  );
};
const PayrollTable = ({ form, name }) => {
  const { payments, _id, status } = form.values;
  const [cellRender] = useCellRender();
  const [formatter] = useFormatter();
  const [exporting, setExporting] = useState(false);
  const [gettingPayment, setGettingPayment] = useState(false);
  const [exportingDetail, setExportingDetail] = useState(false);
  const [exportingOrderDetail, setExportingOrderDetail] = useState(false);
  const [exportingBankFile, setExportingBankFile] = useState(false);
  const [api] = useServerApi();
  const forceUpdate = useForceUpdate();
  const handleExport = async () => {
    if (!_id || exporting) return;
    try {
      const ans = window.confirm(
        "Are you sure to export the bank file? Once exported, all related bids will be settled and the operation can't undo. Please Cancel if you are not sure."
      );
      if (!ans) return;
      setExporting(true);
      let result = await api.Payroll.export(_id);
      console.log("result", result);
      if (!result.success) throw result.error;
      const data = result.data;
      window.open(data.url, "_blank");
      form.setFieldValue("status", "COMPLETED");
      setExporting(false);
    } catch (error) {
      console.log(error);
      setExporting(false);
      showNotification({
        title: "Error",
        message: error.message ?? "Error on exporting bank file",
        color: "red",
      });
    }
  };

  const handleExportDetail = async () => {
    if (!_id || exporting) return;
    try {
      setExporting(true);
      setExportingDetail(true);
      let result = await api.Payroll.exportDetail(_id);
      setExporting(false);
      setExportingDetail(false);

      // console.log(result);
      if (result.url) return await openFileUrl(result.url);
      if (result.error) throw result.error;
    } catch (error) {
      console.log(error);
      setExporting(false);
      setExportingDetail(false);
    }
  };

  const handleExportDetailByOrder = async () => {
    if (!_id || exporting) return;
    try {
      setExporting(true);
      setExportingOrderDetail(true);

      let result = await api.Payroll.exportDetailByOrder(_id);
      setExporting(false);
      setExportingOrderDetail(false);
      console.log(result);
      if (result.url) return await openFileUrl(result.url);
      if (result.error) throw result.error;
    } catch (error) {
      console.log(error);
      setExporting(false);
      setExportingOrderDetail(false);
    }
  };

  const handleGetUpdate = async () => {
    if (!_id || exporting) return;
    try {
      setExporting(true);
      setGettingPayment(true);
      let result = await api.Payroll.getUpdate(_id);
      console.log(result);
      form.setValues(result.payroll);
      setExporting(false);
      setGettingPayment(false);
    } catch (error) {
      console.log(error);
      setExporting(false);
      setGettingPayment(false);
    }
  };

  const handleGetPending = async () => {
    if (!_id || exporting) return;
    try {
      setExporting(true);
      setGettingPayment(true);
      let result = await api.Payroll.getPendingPayroll(_id);
      //   console.log(result.payroll);
      form.setValues(result.payroll);

      setExporting(false);
      setGettingPayment(false);
    } catch (error) {
      //   console.log(error);
      setExporting(false);
      setGettingPayment(false);
    }
  };

  const handleClearAll = async () => {
    if (!_id || exporting) return;
    try {
      const ans = window.confirm("Are you sure to clear all the payments?");
      if (!ans) return;
      setExporting(true);
      let result = await api.Payroll.clearAll(_id);
      // console.log(result);
      form.setValues(result.payroll);
      setExporting(false);
    } catch (error) {
      console.log(error);
      setExporting(false);
    }
  };

  const handleRemoveBid = async (bidIds) => {
    if (!_id || exporting) return;
    try {
      const ans = window.confirm(
        `Are you sure to remove the commission bids (${bidIds.length}) from this payroll?`
      );
      if (!ans) return;
      let result = await api.Payroll.removeBids(_id, bidIds);
      await form.reload();
      forceUpdate();
      return true;
    } catch (error) {
      console.log(error);
      showNotification({
        title: "Error",
        message: error.message ?? "Error on removing commission bid",
        color: "red",
      });
    }
  };

  const handleRemovePayment = async (paymentId) => {
    if (!_id || exporting) return;
    try {
      const ans = window.confirm("Are you sure to remove this payment?");
      if (!ans) return;

      await api.Payroll.removePayment(_id, paymentId);
      await form.reload();
      forceUpdate();
    } catch (error) {
      console.log(error);
    }
  };

  const isGetPendingDisable = () => status === "COMPLETED";

  useEffect(() => {
    if (status !== "PENDING") return;
    handleGetUpdate();
  }, [status, _id]);

  return (
    <>
      {/* <ReactJson src={form.values} style={{ background: "white" }} collapsed /> */}
      <Group position="apart" mt="xl">
        <span></span>
        <Group position="right" mb={"xl"}>
          <Button
            disabled={isGetPendingDisable() || exporting}
            loading={gettingPayment}
            onClick={() => handleGetPending()}
            leftIcon={<IconRefresh size={14} />}
          >
            Get Pending Payment
          </Button>
          <Button
            // color={"green"}
            disabled={exporting}
            loading={exportingDetail}
            onClick={() => handleExportDetail()}
            leftIcon={<IconFile size={14} />}
          >
            Print Detail (Consultant)
          </Button>

          <Button
            // color={"green"}
            disabled={exporting}
            loading={exportingOrderDetail}
            onClick={() => handleExportDetailByOrder()}
            leftIcon={<IconFile size={14} />}
          >
            Print Detail (Order)
          </Button>
          <Button
            color={"orange"}
            disabled={isGetPendingDisable() || exporting}
            loading={gettingPayment}
            onClick={() => handleClearAll()}
            leftIcon={<IconRefresh size={14} />}
          >
            Clear All
          </Button>

          <Button
            color={"red"}
            disabled={exporting}
            loading={exportingBankFile}
            onClick={() => handleExport()}
            leftIcon={<IconFile size={14} />}
          >
            Export Bank File
          </Button>
        </Group>
      </Group>
      <PaymentTab
        payments={payments}
        onRemoveBid={handleRemoveBid}
        payrollStatus={status}
        onRemovePayment={handleRemovePayment}
      />
    </>
  );
};

export default PayrollTable;
